export default __webpack_public_path__ + "static/media/nearshorit-powered-by-MP.bfbefd91.svg";